<template>
    <el-container style="height: calc(100vh - 52px)">
        <el-header style="height: auto;" class="bg-gray-200 p-3 md:p-5">
            <div class="flex w-full flex-col md:flex-row">
                <!-- 検索部 -->
                <div class="hidden md:block bg-white border-2 border-gray-400 rounded-md p-4">
                    <el-form :model="searchForm" label-width="auto" label-position="top">
                        <div class="grid gap-4"
                            :class="[
                                loginUserRole === ROLES.SYSTEM ? 'md:grid-cols-6' : 'md:grid-cols-5',
                            ]">
                            <el-form-item class="no-margin"
                                v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                                <OrganizationSelect v-model="searchForm.organization_id" :is-search="true" placeholder="組織を選択" />
                            </el-form-item>

                            <el-form-item class="no-margin" v-show="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" label="部門">
                                <DepartmentSelect :organization-id="searchForm.organization_id" :is-search="true" v-model="searchForm.department_id" placeholder="部門を選択"
                                    @organization-id-change="searchForm.organization_id = $event" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="ユーザー">
                                <UserSelect 
                                    :organization-id="searchForm.organization_id" 
                                    :is-search="true" v-model="searchForm.user_id" 
                                    placeholder="ユーザーを選択" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="開始日">
                                <el-date-picker :is-search="true" v-model="searchForm.start_date" type="datetime" placeholder="開始日時を選択" />
                            </el-form-item>

                            <el-form-item class="no-margin" label="終了日">
                                <el-date-picker :is-search="true" v-model="searchForm.end_date" type="datetime" placeholder="終了日時を選択" />
                            </el-form-item>

                            <div class="flex justify-end mt-7">
                                <el-button class="hidden md:block w-24" type="info"
                                    @click="handleSearchButton">検索</el-button>
                            </div>
                        </div>
                    </el-form>
                </div>

                <el-drawer class="md:hidden bg-gray-200" v-model="drawer" title="検索" direction="ttb" :with-header="false" size="auto">
                    <div class="bg-white border-2 border-gray-400 rounded-md p-4">
                        <el-form :model="searchForm" label-width="auto" label-position="top">
                            <div class="grid gap-4">
                                <el-form-item class="no-margin"
                                    v-show="loginUserRole === ROLES.SYSTEM" label="組織">
                                    <OrganizationSelect v-model="searchForm.organization_id" :is-search="true" placeholder="組織を選択" />
                                </el-form-item>

                                <el-form-item class="no-margin" v-show="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" label="部門">
                                    <DepartmentSelect :organization-id="searchForm.organization_id" :is-search="true" v-model="searchForm.department_id" placeholder="部門を選択"
                                        @organization-id-change="searchForm.organization_id = $event" />
                                </el-form-item>

                                <el-form-item class="no-margin" label="開始日">
                                    <el-date-picker :is-search="true" v-model="searchForm.start_date" type="datetime" placeholder="開始日時を選択" />
                                </el-form-item>

                                <el-form-item class="no-margin" label="終了日">
                                    <el-date-picker :is-search="true" v-model="searchForm.end_date" type="datetime" placeholder="終了日時を選択" />
                                </el-form-item>

                                <div class="flex">
                                    <el-form-item class="no-margin flex-grow" label="ユーザー">
                                        <UserSelect 
                                            :organization-id="searchForm.organization_id" 
                                            :is-search="true" v-model="searchForm.user_id" 
                                            placeholder="ユーザーを選択" />
                                    </el-form-item>

                                    <div class="flex justify-end mt-7">
                                        <el-button class="md:hidden ml-3" type="info" @click="handleSearchButton" circle>
                                            <el-icon>
                                                <span class="material-symbols-outlined">manage_search</span>
                                            </el-icon>
                                        </el-button>
                                    </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </el-drawer>

                <!-- 操作部 -->
                <div class="flex justify-end items-center md:flex-grow">
                    <el-button class="custom-icon-btn md:hidden" type="info" 
                        @click="drawer = true" circle>
                        <span class="material-symbols-outlined">
                            manage_search
                        </span>
                    </el-button>

                    <el-button class="custom-icon-btn" type="info" 
                        @click="handleExportButton" circle>
                        <span class="material-symbols-outlined">
                            download_2
                        </span>
                    </el-button>
                </div>
            </div>
        </el-header>

        <el-mian style="padding-bottom: 20px;">
            <!-- 手机CARD部 -->
            <div class="md:hidden" v-loading="loading" style="height: calc(100vh - 177px)">
                <div class="custom-title flex flex-col">
                    <span>履歴マスタ</span>
                    <div class="ml-auto">                        
                        <div class="flex items-center space-x-1">
                            <span class="text-white">ソート:</span>
                            <el-button 
                                size="small" 
                                @click="handleSort('action_time')"
                                :class="['mobile-sort-btn', sortField === 'action_time' ? 'active' : '']">
                                日時
                            </el-button>
                            <el-button 
                                size="small" 
                                @click="handleSort('user_name')"
                                :class="['mobile-sort-btn', sortField === 'user_name' ? 'active' : '']">
                                ユーザー    
                            </el-button>
                            <span class="text-white">アイテム数: {{ mTotalRecords }}</span>
                        </div>
                    </div>
                </div>

                <div style="height: calc(100vh - 227px); overflow-y: auto;">
                    <el-card style="border: 1px solid #d1d5db; border-radius: 0px"
                        v-for="item in mTableData" :key="item.history_id">
                        <el-row align="middle">
                            <el-col :span="2">
                                <el-button
                                    class="w-8 h-16"
                                    type="info" 
                                    style="background-color: #b7b7b7;"
                                    text
                                    bg
                                    @click="handleDetailButton(item)">
                                    <span>詳<br>細</span>
                                </el-button>
                            </el-col>

                            <el-col :span="20" class="ml-2">
                                <el-row align="middle">
                                    <div class="flex-grow" v-if="loginUserRole === ROLES.SYSTEM">{{ item.organization_name }}</div>
                                    <div v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)">{{ item.department_name }}</div>
                                </el-row>
                                <div>{{ item.user_name }}</div>
                                <div>{{ item.action }}</div>
                                <div>{{ moment(item.action_time).format('YYYY-MM-DD HH:mm:ss') }}</div>
                            </el-col>
                        </el-row>
                    </el-card>
                </div>
            </div>

            <!-- WEB表格部 -->
            <div class="hidden md:block w-full">
                <el-table :data="mTableData" height="calc(100vh - 260px)" v-loading="loading">
                    <el-table-column label="履歴確認" width="100" align="center">
                        <template #default="scope">
                            <el-button
                                class="w-12"
                                type="info"
                                style="background-color: #b7b7b7;"
                                text
                                bg
                                @click="handleDetailButton(scope.row)">
                                <span>詳細</span>
                            </el-button>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="loginUserRole === ROLES.SYSTEM" prop="organization_name" label="所属組織" width="200">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('organization_name')">
                                <span>{{ getSortLabel('organization_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'organization_name' }">
                                        {{ getSortIcon('organization_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="loginUserRole === ROLES.SYSTEM || (loginUserRole === ROLES.ADMIN && loginUserRoleIsHead)" prop="department_name" label="所属部門" width="160">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('department_name')">
                                <span>{{ getSortLabel('department_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'department_name' }">
                                        {{ getSortIcon('department_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_name" label="操作者名" width="140">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('user_name')">
                                <span>{{ getSortLabel('user_name') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'user_name' }">
                                        {{ getSortIcon('user_name') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="action" label="操作内容">
                    </el-table-column>
                    <el-table-column prop="action_time" label="操作日" width="160">
                        <template #header>
                            <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('action_time')">
                                <span>{{ getSortLabel('action_time') }}</span>
                                <el-icon class="ml-1 flex-shrink-0">
                                    <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'action_time' }">
                                        {{ getSortIcon('action_time') }}
                                    </span>
                                </el-icon>
                            </div>
                        </template>
                        <template #default="scope">
                            {{ moment(scope.row.action_time).format('YYYY-MM-DD HH:mm:ss') }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页部 -->
            <div class="flex w-full justify-end mt-4">
                <div class="hidden md:block mr-3">
                    <el-pagination v-model:current-page="mCurrentPage" v-model:page-size="mPageSize"
                        :page-sizes="[10, 20, 50, 100]" layout="total, sizes, prev, pager, next, jumper"
                        :total="mTotalRecords" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>

                <div class="md:hidden">
                    <el-pagination layout="prev, pager, next" :total="mTotalRecords"
                    @current-change="handleCurrentChange" />
                </div>
            </div>
        </el-mian>
    </el-container>

    <!-- 新規登録更新对话框 -->
    <el-dialog class="custom-dialog" modal-class="custom-dialog-modal" style="max-width:800px"
        v-model="dialogFormVisible" title="詳細" align-center>
        <div class="flex flex-col md:flex-row gap-4">
            <!-- 左侧 -->
            <div class="w-full md:w-1/2">
                <el-form :model="form" ref="formRef" label-width="100px">
                    <el-form-item label="所属組織" prop="organization_name">
                        <el-input v-model="form.organization_name" autocomplete="off" readonly />
                    </el-form-item>
                    <el-form-item label="所属部門" prop="department_name">
                        <el-input v-model="form.department_name" autocomplete="off" readonly />
                    </el-form-item>
                    <el-form-item label="操作者名" prop="user_name">
                        <el-input v-model="form.user_name" autocomplete="off" readonly />
                    </el-form-item>
                    <el-form-item label="操作内容" prop="action">
                        <el-input v-model="form.action" autocomplete="off" readonly />
                    </el-form-item>
                    <el-form-item label="操作日" prop="action_time">
                        <el-input v-model="form.action_time" autocomplete="off" readonly />
                    </el-form-item>
                </el-form>
            </div>

            <!-- 右侧：仅保留一个框，按「項目名: 値」逐行填充 -->
            <div class="w-full md:w-1/2">
                <el-form :model="form" ref="formRef" label-width="100px" label-position="top">
                    <el-form-item label="詳細内容" prop="other_info">
                        <el-input :model-value="detailText" autocomplete="off" type="textarea" :autosize="{ minRows: 5 }" readonly />
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <template #footer>
            <div class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible = false">
                    確認
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script lang="ts">
import axios, { AxiosResponse } from 'axios';
import { ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn } from 'element-plus';
import { defineComponent, onMounted, ref, nextTick, computed } from 'vue';
import type { FormInstance, FormRules } from 'element-plus';
import { ErrorCode,  ResponseData, ResponseStatus } from '@/components/common/response';
import { getErrorMessage, PageType } from '@/components/common/errorMessage';
import { SearchRequest } from '@/components/common/request';
import moment from 'moment';
import { ALL, ROLES } from '@/config/constants';
import OrganizationSelect from '@/components/common/OrganizationSelect.vue';
import DepartmentSelect from '@/components/common/DepartmentSelect.vue';
import UserSelect from '@/components/common/UserSelect.vue';


interface HistoryInfo {
    history_id: string,
    organization_name?: string,
    department_name?: string,
    user_name?: string,
    action_time?: string,
    action?: string,
    other_info?: string,
}

export default defineComponent({
    name: 'MngLog',
    components: {
        ElTable,
        ElTableColumn,
        ElPagination,
        OrganizationSelect,
        DepartmentSelect,
        UserSelect,
    },
    setup() {
        const loginUserRole = localStorage.getItem('role');
        const loginUserRoleIsHead = localStorage.getItem('is_head') === '1';

        const searchForm = ref<any>({
            organization_id: ALL,
            department_id: ALL,
            user_id: '',
            start_date: moment().startOf('day').toDate(),
            end_date: '',
        });

        const form = ref<HistoryInfo>({
            history_id: ''
        });

        const drawer = ref(false);

        const loading = ref<boolean>(true);

        // 表格相关状态
        const mTableData = ref<HistoryInfo[]>([]);          // 排序完成，显示在表格里的数据（单页的数据）
        const mAllData = ref<HistoryInfo[]>([]);            // 存储所有查询结果（最大1000件）
        // 分页相关状态
        const mTotalPages = ref<number>(0);
        const mTotalRecords = ref<number>(0);
        const mCurrentPage = ref<number>(1);
        const mPageSize = ref<number>(10);
        const hasMoreData = ref<boolean>(false); // 添加hasMoreData状态

        // 排序相关状态
        const sortField = ref<string>('action_time'); // 当前排序字段
        const sortOrder = ref<'asc' | 'desc'>('desc'); // 当前排序方向

        // 排序配置 - 方便添加新的排序字段
        const sortConfig = {
            'action_time': {
                label: '操作日時',
                mobileLabel: '操作日時',
                type: 'date' as const,
                defaultOrder: 'desc' as const
            },
            'user_name': {
                label: '操作者名',
                mobileLabel: '操作者名',
                type: 'string' as const,
                defaultOrder: 'desc' as const
            },
            'organization_name': {
                label: '所属組織',
                mobileLabel: '所属組織',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'department_name': {
                label: '所属部門',
                mobileLabel: '所属部門',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'action': {
                label: '操作内容',
                mobileLabel: '操作内容',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            }
        };

        const size = ref<string>('small');
        const disabled = ref<boolean>(false);
        const background = ref<boolean>(true);

        const dialogFormVisible = ref<boolean>(false);

        // 明细解析与类型判断
        const parsedOther = ref<any>(null);
        const detailType = ref<string>("");

        const parseOtherInfo = (text?: string) => {
            if (!text) return null;
            try {
                return JSON.parse(text);
            } catch {
                return null;
            }
        };
        
        // 支持 'a.b.c' 路径取嵌套属性值
        function getVal(obj: any, path: string): any {
            if (!obj || typeof obj !== 'object' || !path) return '';
            return path.split('.').reduce((o, k) => (o && o[k] !== undefined ? o[k] : ''), obj);
        }

        const formRef = ref<FormInstance>()

        /***** マウント **************************/
        onMounted(() => {
            getHistoryList();
        });

        /***** ボタン **************************/
        const handleSearchButton = () => {
            drawer.value = false;
            mCurrentPage.value = 1; // 重置到第一页
            getHistoryList();
        };

        const handleDetailButton = (row: HistoryInfo) => {
            dialogFormVisible.value = true;
            nextTick(() => {
                formRef.value?.resetFields();
                form.value = {
                    history_id: row.history_id,
                    organization_name: row.organization_name,
                    department_name: row.department_name,
                    user_name: row.user_name,
                    action_time: row.action_time,
                    action: row.action,
                    other_info: row.other_info,
                };
                parsedOther.value = parseOtherInfo(row.other_info);
                detailType.value = resolveDetailType(row.action);
            });
        };

        const handleExportButton = () => {
            ElMessageBox.confirm('履歴確認をエクスポートしますか？', 'CSVエクスポート', {
                confirmButtonText: 'エクスポート',
                cancelButtonText: 'キャンセル',
                type: 'warning',
            }).then(() => {
                exportHistory();
            }).catch(() => {
                // console.log('削除キャンセル');
            });
        };

        const handleSizeChange = (size: number) => {
            mPageSize.value = size;
            calculatePagination();
        };
        
        const handleCurrentChange = (page: number) => {
            mCurrentPage.value = page;
            calculatePagination();
        };

        // 处理排序
        const handleSort = (field: string) => {
            if (sortField.value === field) {
                // 如果点击的是当前排序字段，切换排序方向
                sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
            } else {
                // 如果点击的是新字段，使用该字段的默认排序方向
                sortField.value = field;
                sortOrder.value = sortConfig[field as keyof typeof sortConfig]?.defaultOrder || 'desc';
            }
            calculatePagination();
        };

        // 获取排序图标
        const getSortIcon = (field: string) => {
            if (sortField.value !== field) {
                return 'unfold_more'; // 未排序状态
            }
            return sortOrder.value === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
        };

        // 获取排序字段的标签
        const getSortLabel = (field: string, isMobile: boolean = false) => {
            const config = sortConfig[field as keyof typeof sortConfig];
            return config ? (isMobile ? config.mobileLabel : config.label) : field;
        };

        // 比较函数工厂
        const createComparator = (field: string, order: 'asc' | 'desc') => {
            const config = sortConfig[field as keyof typeof sortConfig];
            const fieldType = config?.type || 'string';
            
            return (a: HistoryInfo, b: HistoryInfo) => {
                let aValue: any = a[field as keyof HistoryInfo];
                let bValue: any = b[field as keyof HistoryInfo];
                
                // 根据字段类型进行特殊处理
                switch (fieldType) {
                    case 'date':
                        aValue = new Date(aValue || 0).getTime();
                        bValue = new Date(bValue || 0).getTime();
                        break;
                    case 'string':
                        if (typeof aValue === 'string' && typeof bValue === 'string') {
                            aValue = aValue.toLowerCase();
                            bValue = bValue.toLowerCase();
                        }
                        break;
                }
                
                // 处理空值
                if (aValue === null || aValue === undefined) aValue = '';
                if (bValue === null || bValue === undefined) bValue = '';
                
                let comparison = 0;
                if (aValue < bValue) comparison = -1;
                if (aValue > bValue) comparison = 1;
                
                // 根据排序方向返回结果
                return order === 'asc' ? comparison : -comparison;
            };
        };

        // 前端分页计算（支持多项目排序）
        const calculatePagination = () => {
            // 使用比较函数工厂创建排序函数
            const comparator = createComparator(sortField.value, sortOrder.value);
            
            // 对数据进行排序
            const sortedData = [...mAllData.value].sort(comparator);
            
            // 计算分页
            const startIndex = (mCurrentPage.value - 1) * mPageSize.value;
            const endIndex = startIndex + mPageSize.value;
            
            mTableData.value = sortedData.slice(startIndex, endIndex);
            mTotalRecords.value = mAllData.value.length;
            mTotalPages.value = Math.ceil(mAllData.value.length / mPageSize.value);
        };
        

        /***** DB 操作 **************************/
        const getHistoryList = async () => {
            try {
                loading.value = true;
                const params: SearchRequest = {
                    organization_id: searchForm.value.organization_id === ALL ? '' : searchForm.value.organization_id,
                    department_id: searchForm.value.department_id === ALL ? '' : searchForm.value.department_id,
                    user_id: searchForm.value.user_id,
                    start_date: searchForm.value.start_date,
                    end_date: searchForm.value.end_date,
                };
                
                const res: AxiosResponse<ResponseData<HistoryInfo[]>> = await axios.get('/api/history/search', { params });
                if (res.status === ResponseStatus.SUCCESS && res.data.code === ErrorCode.OK) {
                    const { data, hasMoreData: moreData } = res.data;

                    mAllData.value = data || [];
                    hasMoreData.value = moreData || false; // 设置hasMoreData状态

                    // 计算分页
                    calculatePagination();

                    // 如果有更多数据，显示提示信息
                    if (hasMoreData.value) {
                        ElMessage({
                            message: '検索結果が1000件を超えています。より詳細な検索条件を設定してください。',
                            type: 'warning',
                            duration: 5000,
                            showClose: true
                        });
                    }

                } else {
                    ElMessage.error(getErrorMessage(PageType.HISTORY, res.data.code));
                }

            } catch (error) {
                ElMessage.error(getErrorMessage(PageType.HISTORY));
            } finally {
                loading.value = false;
            }
        };

        const exportHistory = async () => {
            try {
                
                const params: SearchRequest = {
                    organization_id: searchForm.value.organization_id === ALL ? '' : searchForm.value.organization_id,
                    department_id: searchForm.value.department_id === ALL ? '' : searchForm.value.department_id,
                    user_id: searchForm.value.user_id,
                    start_date: searchForm.value.start_date,
                    end_date: searchForm.value.end_date,
                };

                console.log(params);
                // 将参数放到 data 字段中，确保条件正确传递到后台
                const res: AxiosResponse<any> = await axios.post(`/api/history/export`, { 
                    organization_id: params.organization_id,
                    department_id: params.department_id,
                    user_id: params.user_id,
                    start_date: params.start_date,
                    end_date: params.end_date
                }, {
                    responseType: 'blob'  // 设置响应类型为 blob
                });
                
                // 修复条件判断：当responseType为blob时，res.data是Blob对象，没有code属性
                if (res.status === ResponseStatus.SUCCESS) {
                     // 创建 Blob 对象并触发文件下载
                    const bom = '\uFEFF'; // UTF-8 BOM
                    // 修复：res.data已经是Blob对象，需要先读取其内容
                    const csvText = await res.data.text();
                    const blob = new Blob([bom + csvText], { type: 'text/csv;charset=utf-8;' });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = '履歴確認_'+ moment(new Date().toISOString()).format('YYYYMMDDHHmmss') +'.csv';  // 指定下载的文件名
                    link.click();
                } else {
                    ElMessage.error(getErrorMessage(PageType.HISTORY, res.data.code));
                }
            }
            catch (error) {
                ElMessage.error(getErrorMessage(PageType.HISTORY));
            }
        };



        // "ユーザログイン
        // "ユーザログアウト
        // "ユーザパスワード変更

        // "アイテム作成
        // "アイテム更新
        // "アイテム削除
        // "アイテムインポート
        // "アイテムエクスポート

        // "組織作成
        // "組織更新
        // "組織削除
        // "組織インポート
        // "組織エクスポート

        // "部門作成
        // "部門更新
        // "部門削除
        // "部門インポート
        // "部門エクスポート

        // "カテゴリ作成
        // "カテゴリ更新
        // "カテゴリ削除
        // "カテゴリインポート
        // "カテゴリエクスポート

        // "ユーザ作成
        // "ユーザ更新
        // "ユーザ削除
        // "ユーザインポート
        // "ユーザエクスポート

        // "ユーザ通知トークン削除

        // "履歴エクスポート
        
        // "環境 メール設定更新
        // "環境 通知設定更新
        // "環境 アプリID更新

        // "JANCODE作成
        // "JANCODE更新
        // "JANCODE削除

        // "インベントリ作成
        // "インベントリ更新
        // "インベントリ削除
        // "インベントリインポート
        // "インベントリエクスポート

        // "払い出し

        // "アラート削除
        // "アラート全削除
        // "アラートエクスポート

        // "定数管理エクスポート


        // // action到日志大类归一映射，对应后端分类
        const resolveDetailType = (action?: string): string => {
            if (!action) return "";
            // === 用户大类 ===
            console.log(action);

            if (action.includes('パスワード') ||
                action.includes('ログイン') || action.includes('ログアウト')
            ) return 'no_detail';

            if (action.includes('インポート')) return 'import';
            
            if (action.includes('エクスポート')) return 'export';

            if (action.includes('通知トークン')) return 'notification';
            
            if (action.includes('ユーザ')) return 'user';
            // === 物品(Material) ===            
            if (action.includes('アイテム')) return 'material';
            // === 组织(組織) ===
            if (action.includes('組織')) return 'organization';
            // === 部门(部門) ===
            if (action.includes('部門')) return 'department';
            // === 类别(カテゴリ) ===
            if (action.includes('カテゴリ')) return 'category';
            // === JANCODE ===
            if (action.includes('JANCODE')) return 'jancode';
            // === 库存(インベントリ) & 払い出し処理 ===
            if (action.includes('インベントリ')) return 'inventory';

            if (action.includes('払い出し')) return 'payment';
            // === 环境(環境) ===
            if (action.includes('環境')) return 'env';
            // === 警告(アラート) ===
            if (action.includes('アラート')) return 'alert';
            // === 定数管理/特殊履历 ===
            if (action.includes('定数管理')) return 'constant';
            
            if (action.includes('履歴')) return 'history';
            return '';
        };


        // 按大类输出主要字段，更易维护
        const detailFields = computed(() => {
            const obj = parsedOther.value || {};
            const type = detailType.value;
            const fields: Array<{ label: string, value: any }> = [];

            // 用 getVal 支持嵌套对象路径
            const pushIf = (label: string, key: string) => {
                const v = getVal(obj, key);
                if (v !== undefined && v !== null && v !== '') fields.push({ label, value: v });
            };

            if (!type || !obj || typeof obj !== 'object') return fields;

            // 各类型字段见下方配置，后端变动只维护这几类即可
            switch (type) {
                case 'no_detail':
                    // 登入登出时，没有详细信息
                case 'export':
                    // 导出时，没有详细信息
                case 'constant':
                    // 定数管理时，只有导出没有详细信息
                    break;
                case 'import':
                    // 导入时，只有件数信息
                    pushIf('メッセージ', 'message');
                    pushIf('総数', 'totalCount');
                    pushIf('成功数', 'validCount');
                    pushIf('失敗数', 'invalidCount');
                    break;
                case 'payment':                    
                    pushIf('所属組織', 'inventorySource.organization_name');
                    pushIf('アイテム名', 'inventorySource.material_name');
                    pushIf('払出元　部門', 'inventorySource.department_name');
                    pushIf('払出元　JANCODE', 'inventorySource.jancode');
                    pushIf('払出元　入庫日', 'inventorySource.storage_date');
                    pushIf('払出元　使用期限', 'inventorySource.expiration_date');
                    pushIf('払出元　数量', 'inventorySource.quantity');
                    pushIf('払出元　保管場所', 'inventorySource.location');
                    pushIf('払出元　担当者', 'inventorySource.responsible_person');
                    pushIf('払出元　コメント', 'inventorySource.comment');

                    pushIf('払出先　部門', 'dest_department_id');
                    
                    pushIf('払出量', 'transfer_quantity');

                    pushIf('メモ', 'transfer_memo');
                    break;
                case 'notification':
                    pushIf('ユーザーID', 'user_id');
                    pushIf('ユーザー名', 'username');
                    pushIf('メール', 'email');
                    pushIf('所属組織', 'organization_name');
                    pushIf('所属部門', 'department_name');
                    break;
                case 'inventory':
                    pushIf('アイテム名', 'material_name');
                    // pushIf('アイテムコード', 'material_code');
                    pushIf('数量', 'quantity');
                    pushIf('カテゴリ', 'category_name');
                    pushIf('部門', 'department_name');
                    pushIf('JANCODE', 'jancode');
                    pushIf('担当者', 'responsible_person');
                    pushIf('コメント', 'comment');
                    pushIf('入庫日', 'storage_date');
                    pushIf('使用期限', 'expiration_date');
                    pushIf('保管場所', 'location');

                    break;
                case 'material':
                    pushIf('アイテム名', 'name');
                    pushIf('所属カテゴリ', 'category_name');
                    // pushIf('アイテムコード', 'material_code');
                    pushIf('JANCODE', 'jancode');
                    pushIf('メーカー', 'maker');
                    pushIf('使用期限(日)', 'expiration_day');
                    pushIf('説明', 'description');
                    break;
                case 'user':
                    // pushIf('ユーザーID', 'user_id');
                    pushIf('ユーザー名', 'username');
                    pushIf('メール', 'email');
                    pushIf('所属組織', 'organization_name');
                    pushIf('所属部門', 'department_name');
                    pushIf('有効/無効', 'is_actived');
                    pushIf('管理者', 'is_admin');
                    break;
                case 'organization':
                    pushIf('組織ID', 'organization_id');
                    pushIf('組織名', 'name');
                    break;
                case 'department':
                    pushIf('部門ID', 'department_id');
                    pushIf('部門名', 'name');
                    pushIf('所属組織', 'organization_name');
                    pushIf('本部か否か', 'is_head');
                    break;
                case 'category':
                    pushIf('カテゴリID', 'category_id');
                    pushIf('カテゴリ名', 'name');
                    break;
                case 'jancode':
                    // \"codeType\":\"\",
                    // \"makerName\":\"メーカー名\",
                    // \"itemImageUrl\":\"\",
                    // \"ProductDetails\":[],
                    // \"codeNumber\":\"4988011511586\",
                    // \"brandName\":\"ブランド名\",
                    // \"itemUrl\":\"\",
                    // \"makerNameKana\":
                    // \"会社名(カナ)\",
                    // \"itemModel\":\"品番\",
                    // \"itemName\":\"商品名-4988011511586\"
                    pushIf('商品名', 'itemName');
                    pushIf('コード番号', 'codeNumber');
                    pushIf('コードタイプ', 'codeType');
                    pushIf('メーカー名', 'makerName');
                    pushIf('商品画像URL', 'itemImageUrl');
                    pushIf('商品詳細', 'ProductDetails');  
                    pushIf('ブランド名', 'brandName');
                    pushIf('商品URL', 'itemUrl');
                    pushIf('メーカー名(カナ)', 'makerNameKana');
                    pushIf('品番', 'itemModel');
  
                    break;
                case 'env':
                    pushIf('通知タイトル', 'notificationSubject');
                    pushIf('通知内容', 'notificationText');
                    pushIf('メールアカウント', 'emailAccount');
                    pushIf('メールパスワード', 'emailPassword');
                    pushIf('メールサーバーURL', 'emailServerUrl');
                    pushIf('メールサーバーポート', 'emailServerPort');
                    pushIf('メール送信者', 'emailSender');
                    pushIf('メール件名', 'emailSubject');
                    pushIf('メール本文', 'emailText');

                    break;
                case 'alert':
                    pushIf('メッセージID', 'message_id');
                    pushIf('タイトル', 'title');
                    pushIf('内容', 'content');
                    pushIf('レベル', 'level');
                    break;
                case 'history':
                    Object.keys(obj).forEach(k => pushIf(k, k));
                    break;
            }
            return fields;
        });

        const prettyOtherJson = computed(() => {
            if (!parsedOther.value) return '';
            try {
                return JSON.stringify(parsedOther.value, null, 2);
            } catch {
                return '';
            }
        });

        // 汇总为单文本框显示：優先「項目名: 値」逐行，其次 JSON，再次原文
        const detailText = computed(() => {
            if (detailFields.value && detailFields.value.length > 0) {
                return detailFields.value.map(i => `${i.label}: ${i.value ?? ''}`).join('\n');
            }
            if (prettyOtherJson.value) return prettyOtherJson.value;
            return form.value.other_info || '';
        });

        return {
            searchForm,
            form,
            dialogFormVisible,
            loading,
            mTableData,
            mCurrentPage,
            mPageSize,
            mTotalPages,
            mTotalRecords,
            size,
            disabled,
            background,
            handleSearchButton,
            handleDetailButton,
            handleSizeChange,
            handleCurrentChange,
            handleExportButton,
            formRef,
            ROLES,
            loginUserRoleIsHead,
            loginUserRole,
            drawer,
            moment,
            hasMoreData,
            sortField,
            sortOrder,
            handleSort,
            getSortIcon,
            getSortLabel,
            detailType,
            detailFields,
            prettyOtherJson,
            detailText
        }
    }
});
</script>

<style scoped>
.sort-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.sort-header:hover {
    background-color: #f5f7fa;
}

/* 确保表头内容不换行 */
:deep(.el-table .el-table__header-wrapper .el-table__header th) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 手机端排序按钮样式 */
.mobile-sort-btn {
    padding: 1px 4px;
    font-size: 11px;
    border-radius: 3px;
    transition: all 0.2s;
    white-space: nowrap;
    min-width: auto;
    height: 20px;
    line-height: 1;
    background-color: white;
    border: 1px solid #d1d5db;
}

.mobile-sort-btn:hover {
    background-color: #f8f9fa;
    color: #409eff;
    border-color: #409eff;
}

.mobile-sort-btn.active {
    background-color: #e6f7ff;
    color: #409eff;
    border-color: #409eff;
}
</style>